import React from 'react';
import { HiOutlineMail } from 'react-icons/hi';
import { FaLinkedinIn } from 'react-icons/fa6';
import './Team.css';

const founders = [
  {
    name: 'Paul Brown',
    role: 'CEO & Co-Founder',
    age: 36,
    email: 'paul@aiscaler.app',
    bio: 'Paul leads AIScaler\'s vision and strategy. With deep experience in scaling technology products and building high-performance teams, she drives the company\'s mission to make AI-powered media enhancement accessible to everyone.',
    initials: 'PB',
    gradient: 'linear-gradient(135deg, #6C3CE1 0%, #F72585 100%)',
  },
  {
    name: 'George Smith',
    role: 'CTO & Co-Founder',
    age: 32,
    email: 'george@aiscaler.app',
    bio: 'George architects AIScaler\'s AI engine and technical infrastructure. She brings extensive expertise in machine learning, computer vision, and distributed systems to build the GPU-accelerated processing pipeline that powers the platform.',
    initials: 'GS',
    gradient: 'linear-gradient(135deg, #06D6A0 0%, #3B82F6 100%)',
  },
];

export default function Team() {
  return (
    <div className="team-page">
      <section className="page-hero">
        <div className="container">
          <span className="section-label">Our Team</span>
          <h1 className="section-title">Meet the Founders</h1>
          <p className="section-subtitle">
            AIScaler is built by a passionate team dedicated to pushing the boundaries of AI-powered media enhancement.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="team-grid">
            {founders.map(({ name, role, email, bio, initials, gradient }) => (
              <div key={name} className="card team-card">
                <div className="team-card__avatar" style={{ background: gradient }}>
                  <span>{initials}</span>
                </div>
                <h3 className="team-card__name">{name}</h3>
                <p className="team-card__role">{role}</p>
                <p className="team-card__bio">{bio}</p>
                <div className="team-card__links">
                  <a href={`mailto:${email}`} className="team-card__link" title={email}>
                    <HiOutlineMail /> {email}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hiring CTA */}
      <section className="section team-hiring">
        <div className="container" style={{ textAlign: 'center' }}>
          <span className="section-label">Careers</span>
          <h2 className="section-title">Join Our Team</h2>
          <p className="section-subtitle" style={{ margin: '0 auto 32px' }}>
            We're always looking for talented people who are passionate about AI and building great products.
            Reach out to us if you'd like to be part of the AIScaler journey.
          </p>
          <a href="mailto:info@aiscaler.app" className="btn btn-primary">
            Get in Touch <HiOutlineMail />
          </a>
        </div>
      </section>
    </div>
  );
}
